const flagEnabled = (value, fallback = false) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
    if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  }
  return fallback;
};

const env = typeof import.meta !== 'undefined' ? import.meta.env || {} : {};

const featureToggles = {
    // on
    showActivities: true,      // Toggles the "Activities" menu
    showDiscover: true,        // Toggles the "Discover" button
    showCreate: true,          // Toggles the "Create" button
    showNews: true,            // Toggles the "News" button
    createPost: true,
    
    //off
    showAdministration: false,  // Toggles the "House" menu
    showCryptoTreasury: flagEnabled(env.VITE_FEATURE_CRYPTO_TREASURY, false),
  };
  
  export default featureToggles;
  
